<!-- eslint-disable -->
<template>
 <!-- <span class="c2_childless_org_alignment_spacer" v-if="!location.nodes"></span> -->
  <div 
    class="c2_org_sys_div"
    :style="C_indent"  
    :class="{
      c2_org_div: C_showCollapseButton === true || 
                  (searchQuery !== false && !location.orgs),
      c2_parent_org_selected: location.isOrg && selectedItemKey === location.key}"
  >
    <div :class="{G_hidden_element: C_showSelf === false}">
      <div 
        v-if="location.uid !== null && location.uid !== undefined && 
              location.isOrg === true &&
              DV_hidePartnerOrg === false"              
        :class="{
          c2_org_entry:C_showSelf === true,
          G_hidden_element: C_showSelf === false}"
      > 
        <span class="c2_childless_org_alignment_spacer" v-if="!location.nodes"></span>
        <span 
          class="c2_expand_collapse_icon"
          :class="{
            'c2_expand_collapse': (depth !== 0 && 
            (C_showExpandButton === true || C_showCollapseButton === true ))}"
        >
          <span 
            class="fas fa-plus-square c2_fa_font"
            @click.stop="showChildren" 
            v-if="C_showExpandButton === true"
          ></span>
          <span 
            class="fas fa-minus-square c2_fa_font"
            @click.stop="hideChildren" 
            v-if="C_showCollapseButton === true"
          ></span>
        </span>
        <span 
          class="c2_org_icon_container c2_org_info_tooltip" 
          :class="{
            'c2_org_icon_container_with_icon': 
            C_showExpandButton === true || C_showCollapseButton === true,
            'c2_org_icon_container_with_zero_depth': 
              depth === 0 && (C_showExpandButton === false && C_showCollapseButton === false),
            'c2_org_selected': location.isOrg && selectedItemKey === location.key,
            'c2_not_selected': selectedItemKey !== location.key}"
        >
          <span class="c2_org_icon" @click.stop="selectOrg"> 
            {{ C_organizationName }}
          </span>
          <span 
            class="c2_org_info_tooltiptext"
            :class="depth === 0 ? 'c2_org_info_tooltiptext_right' : 'c2_org_info_tooltiptext_top'"><small>{{C_tooltipText}}</small></span>
          <span class="c2_alert_indicator" @click.stop="eventShowDoghouse"> 
            <c19-doghouse-alert-indicator
              v-if="(!showOnlyProblemsCommand || depth <2) &&
                      DV_actualLastOrgUid !== null && DV_actualLastOrgUid !== undefined"
              :orgUid="DV_actualLastOrgUid"
              @event-doghouse-problem-detected="DV_problemDetected = true"
              @event-no-doghouse-problems="DV_problemDetected = false"
            ></c19-doghouse-alert-indicator>
          </span>
        <!-- <start> menu buttons for the org -->
          <span class="c2_org_buttons_container" v-if="selectedItemKey === location.key">
            <button 
              @click.stop="eventShowDoghouse" 
              class="c2_doghouse_button c2_org_buttons"
            ></button>
            <button 
              @click.stop="eventEditOrg" 
              class="c2_edit_button c2_org_buttons"
            ></button>
            <button 
              @click.stop="eventShowReporting" 
              class="c2_report_button c2_org_buttons"
            ></button>
            <span v-if="hasChildOrgs">
              <button 
                @click.stop="expandAllChildren" 
                class="c2_expand_all_button c2_org_buttons"
              ></button>
              <button 
                @click.stop="collapseAllChildren" 
                class="c2_collapse_all_button c2_org_buttons"
              ></button>
            </span>
            <span 
              class="c2_close_button_slider"
              @click.stop="passEventUnSelectItem"
            ></span>
          </span>
        </span>
        <!--</end> menu buttons for the org -->
      </div> 
    </div>

    <div 
      :class="{ 
        c2_show_children: this.C_showChildrenFlag, 
        c2_hide_children: !this.C_showChildrenFlag && location.nodes}"
    >

    <!-- sub orgs that have sub orgs and the systems directly under this org -->
      <c2-System-Org-Tree-Menu
        v-if="location.nodes && DV_actualLastOrgUid !== null"
        :location="location.nodes"
        :depth="DV_childDepth"
        :presetName="presetName"
        :selectedItemKey="selectedItemKey"
        :expandCollapseCommand="DV_expandCollapseCommandToChild"
        :showOnlyProblemsCommand="showOnlyProblemsCommand"
        :lastOrgUid="DV_actualLastOrgUid"
        :searchQueryRequestTimestamp="DV_searchQueryRequestTimestampToChildren"
        :searchQuery="DV_searchQueryToChidlren"
        :searchModeForceChildrenVisible="DV_SearchModeShowChildrenFlag"
        :listenersCommandToChild="DV_listenersCommandToChild"
        :parentKey="DV_actualParentKey"
        :activeOrgUid="activeOrgUid"
        :activeSysUid="activeSysUid"
        @pass-event-show-reporting="passEventShowReporting"
        @pass-select-org="passSelectOrg"
        @pass-select-system="passSelectSystem"
        @pass-event-edit-org="passEventEditOrg"
        @pass-event-edit-sys="passEeventEditSys"
        @pass-event-show-details="passEventShowDetails"
        @pass-event-show-doghouse="passEventShowDoghouse"
        @event-search-query-deep-match="passEventSearchQueryDeepMatch"
        @pass-event-search-query-system-match="passEventSearchQuerySystemMatch"
        @pass-event-unselect-selected-item="passEventUnSelectItem"
        @set-selected-item-key="setSelectedItemKey"
        @event-set-children-visible="passEventSetChildrenVisible"
      > </c2-System-Org-Tree-Menu>
    </div>
        
    <!--orgs that exist within a component container for an org -->
    <div v-if="location.orgs && DV_actualLastOrgUid !== null">
      <c2-System-Org-Tree-Menu
        v-for="org in C_orderedOrganizations"
        :location="org"
        :depth="depth"
        :presetName="presetName"
        :selectedItemKey="selectedItemKey"
        :expandCollapseCommand="DV_expandCollapseCommandToChild"
        :showOnlyProblemsCommand="showOnlyProblemsCommand"
        :lastOrgUid="DV_actualLastOrgUid"
        :key="org.key"
        :searchQueryRequestTimestamp="DV_searchQueryRequestTimestampToChildren"
        :searchQuery="DV_searchQueryToChidlren"
        :searchModeForceChildrenVisible="searchModeForceChildrenVisible"
        :listenersCommandToChild="DV_listenersCommandToChild"
        :parentKey="DV_actualParentKey"
        :activeOrgUid="activeOrgUid"
        :activeSysUid="activeSysUid"
        @pass-event-show-reporting="passEventShowReporting"
        @pass-select-org="passSelectOrg"
        @pass-select-system="passSelectSystem"
        @pass-event-edit-org="passEventEditOrg"
        @pass-event-edit-sys="passEeventEditSys"
        @pass-event-show-details="passEventShowDetails"
        @pass-event-show-doghouse="passEventShowDoghouse"
        @event-search-query-org-match="eventSearchQueryOrgMatch"
        @event-search-query-deep-match="passEventSearchQueryDeepMatch"
        @pass-event-unselect-selected-item="passEventUnSelectItem"
        @set-selected-item-key="setSelectedItemKey"
        @event-set-children-visible="passEventSetChildrenVisible"
      >
      </c2-System-Org-Tree-Menu>
    </div>

    <!--systems that exist within a component container for an org -->
    <div v-if="location.systems && DV_actualLastOrgUid !== null">
      <c2-System-Org-Tree-Menu
        v-for="system in C_orderedSystems"
        :location="system"
        :depth="DV_childDepth"
        :presetName="presetName"
        :selectedItemKey="selectedItemKey"
        :expandCollapseCommand="DV_expandCollapseCommandToChild"
        :showOnlyProblemsCommand="showOnlyProblemsCommand"
        :lastOrgUid="DV_actualLastOrgUid"
        :key="system.key"
        :searchQueryRequestTimestamp="DV_searchQueryRequestTimestampToChildren"
        :searchQuery="DV_searchQueryToChidlren"
        :searchModeForceChildrenVisible="searchModeForceChildrenVisible"
        :listenersCommandToChild="DV_listenersCommandToChild"
        :parentKey="DV_actualParentKey"
        :activeOrgUid="activeOrgUid"
        :activeSysUid="activeSysUid"
        @pass-event-show-reporting="passEventShowReporting"
        @pass-select-org="passSelectOrg"
        @pass-select-system="passSelectSystem"
        @pass-event-edit-org="passEventEditOrg"
        @pass-event-edit-sys="passEeventEditSys"
        @pass-event-show-details="passEventShowDetails"
        @pass-event-show-doghouse="passEventShowDoghouse"
        @event-search-query-system-match="eventSearchQuerySystemMatch"
        @pass-event-unselect-selected-item="passEventUnSelectItem"
        @set-selected-item-key="setSelectedItemKey"
        @event-set-children-visible="passEventSetChildrenVisible"
      >
      </c2-System-Org-Tree-Menu>  
    </div>

    <!--  <start> system entry in the list -->
    <div :class="{G_hidden_element: C_showSelf === false}">
    <div
      v-if="location.isSys && location.uid"
      class="c2_system_entry"
      :style="C_indent"
    > 
      <span class="c2_system_alignment_spacer"></span>
      <span 
        @click.stop="selectSys"
        class="c2_org_icon_container c2_sys_icon_container"
        :class="{
          'c2_sys_selected': location.isSys &&  selectedItemKey === location.key,
          'c2_sys_not_selected': selectedItemKey !== location.key}"
      >
        <c16-sys-online-indicator
          :is-system-visible="DV_showSystemStatusIndicator || DV_showSystemStatusIndicatorForSearch"
          :systemUid="location.uid"
          class="c2_system_online_indicator_mobile"
        ></c16-sys-online-indicator>
        <span class="c2_system_name_mobile">{{ C_systemName }} </span>
        <span 
          class="c2_doghouse_indicator_mobile"
          @click.stop="eventShowDoghouse">
          <c19-doghouse-alert-indicator
            v-if="DV_actualLastOrgUid !== null && DV_actualLastOrgUid !== undefined"
            :orgUid="DV_actualLastOrgUid"
            :systemUid="location.uid"
            @event-doghouse-problem-detected="DV_problemDetected = true"
            @event-no-doghouse-problems="DV_problemDetected = false"
          ></c19-doghouse-alert-indicator>
        </span>
        <!--  <start> menu buttons for the system -->
        <span class="c2_system_buttons" v-if="selectedItemKey === location.key">
          <button @click.stop="eventShowDoghouse" class="c2_doghouse_button c2_org_buttons"></button>
          <button @click.stop="eventShowDetails" class="c2_details_button c2_org_buttons"></button>
          <button 
            v-if="userHasSystemEditPermissions === true"
            @click.stop="eventEditSys" 
            class="c2_edit_button c2_org_buttons"
          ></button>
          <button @click.stop="eventShowReporting" class="c2_report_button c2_org_buttons"></button> 
          <span 
            class="c2_close_button_slider"
            @click.stop="passEventUnSelectItem"
          ></span>
        </span>
      </span>
        <!--</end> menu buttons for the system -->
      </div>
    </div>
    <!-- </end> system entry in the list -->       
  </div>
</template>

<script>
/* eslint-disable */
const c19DoghouseAlertIndicator = () => import('../../Labels/c19DoghouseAlertIndicator')
import c16SysOnlineIndicator from "../../Labels/c16SysOnlineIndicator";
import { bi10OrgPermissions } from "../../../watchdog_includes/base_i10_UI_mixins";
import _ from 'lodash';

export default {
  name: "c2SystemOrgTreeMenu",
  components: {
    c16SysOnlineIndicator,
    c19DoghouseAlertIndicator,
  },
  mixins: [bi10OrgPermissions],
  props: [
    "location",
    "depth",
    "lastOrgUid",
    "presetName",
    "selectedItemKey",
    "expandCollapseCommand",
    "showOnlyProblemsCommand",
    "searchQuery",
    "searchQueryRequestTimestamp",
    "searchModeForceChildrenVisible",
    "listenersCommandToChild",
    "parentKey",
    "activeOrgUid",
    "activeSysUid"
  ],
  data() {
    return {
      DV_showChildrenFlag: this.depth < 1 ? true : false, //0 depth is the root, if that isn't shown you can't expand anything
      DV_SearchModeShowChildrenFlag: false,
      DV_actualLastOrgUid: null,
      DV_problemDetected: null,
      DV_expandCollapseCommandToChild: null,
      DV_searchQueryMatchFlag: false,
      DV_searchQuerySubOrgMatchFlag: false,
      DV_searchQuerySubSystemMatchFlag: false,
      DV_searchQueryDeepMatchFlag: false,
      DV_searchQueryToChidlren: false,
      DV_searchQueryRequestTimestampToChildren: null,
      DV_hidePartnerOrg: true,
      DV_childDepth: this.depth,
      DV_showSystemStatusIndicator: false,
      DV_showSystemStatusIndicatorForSearch: false,

      // uid of current org. child will match this orgUid with lastOrgUid to confirm parent.
      // Command to child to start or stop listeners. True for start and False for stop commands.
      DV_listenersCommandToChild: {'orgUid': null, 'command': false},
      DV_actualParentKey: '' // Used while starting listeners depending the parent's flag to hide or show childs in preset data.
    }
  },
  computed: {
    C_indent() {
      if (this.userHasPermissionsFlag === false) { return "{}"; }
      if(this.location.isOrg && this.location.nodes ){
        return { transform: "translate(" + (2).toString() + "vw)" };
      } else {
        return "{}";
      }
    },
    hasChildOrgs() {
      return this.location.isOrg && this.location.nodes
    },
    C_showSelf() {
      //top level orgs should always be visible unless a search query is running
      if (this.depth < 2 && this.searchQuery === false) {
        return true;
      }

      if (this.searchModeForceChildrenVisible === true) {
        return true;
      }
      if (this.showOnlyProblemsCommand === true && (this.DV_problemDetected === false || !this.DV_problemDetected)) {
        return false;
      }
      if (this.searchQuery !== false && 
      this.DV_searchQueryMatchFlag === false && this.DV_searchQuerySubOrgMatchFlag === false && 
      this.DV_searchQuerySubSystemMatchFlag === false && this.DV_searchQueryDeepMatchFlag === false) {
        return false;
      }

      return true;
    },
    C_showChildrenFlag() {
      //if the partner org hides its children the user can't see the orgs they have access too
      if(this.DV_hidePartnerOrg === true) {
        return true;
      }
      if(this.showOnlyProblemsCommand === true && (this.DV_problemDetected === true || !this.DV_problemDetected)) {
        return true;
      }
      if(this.searchQuery !== false && 
      (this.DV_searchQueryMatchFlag === true || this.DV_searchQuerySubOrgMatchFlag === true || 
      this.DV_searchQuerySubSystemMatchFlag === true || this.DV_searchQueryDeepMatchFlag === true)) {
        this.DV_showSystemStatusIndicatorForSearch = true;
        return true;
      }
      if(this.searchQuery !== false && this.DV_SearchModeShowChildrenFlag === true) {
        this.DV_showSystemStatusIndicatorForSearch = true;
        return true;
      }

      if(this.DV_showChildrenFlag === true) {
        return true;
      }

      this.DV_showSystemStatusIndicatorForSearch = false;

      return false;
      
    },
    C_showExpandButton() {
      if(this.location.nodes === null || this.location.nodes === undefined) {
        return false;
      }
      
      if(this.searchQuery !== false &&
        (this.DV_searchQuerySubSystemMatchFlag === true || this.location.nodes !== null && this.location.nodes !== undefined) &&
        this.DV_SearchModeShowChildrenFlag === false
       ) {
        return true;
      }

      if(this.searchQuery === false && this.DV_showChildrenFlag === false) {
        return true;
      }


      return false;
    },

    C_showCollapseButton() {
      if(this.location.nodes === null || this.location.nodes === undefined) {
        return false;
      }

      if(this.searchQuery !== false &&
        (this.DV_searchQuerySubSystemMatchFlag === true || this.location.nodes !== null && this.location.nodes !== undefined) &&
        this.DV_SearchModeShowChildrenFlag === true
       ) {
        return true;
      }

      if(this.searchQuery === false && this.DV_showChildrenFlag === true) {
        return true;
      }

      return false;
    },

    C_orderedSystems() {
      // return ordered systems
      for (var key in this.location.systems) {
        var uid = this.location.systems[key].uid;

        if (uid !== null && uid !== undefined &&
            uid.replace('sys_','obj_') in this.C_objectsMetaData &&
            this.C_objectsMetaData[uid.replace('sys_','obj_')] !== null &&
            this.C_objectsMetaData[uid.replace('sys_','obj_')] !== undefined &&
            'name' in this.C_objectsMetaData[uid.replace('sys_','obj_')] &&
            typeof(this.C_objectsMetaData[uid.replace('sys_','obj_')]['name']) === 'string') {
          var tempName = this.C_objectsMetaData[uid.replace('sys_','obj_')].name;
          this.location.systems[key]['name'] = tempName;
        } else {
          this.location.systems[key]['name'] = "";
        }
      }

      return _.orderBy(
        this.location.systems,
        function(sys) {
          return sys.name.toLowerCase(); 
        }
      );
    },
    C_orderedOrganizations() {
      // return ordered orgs
      for (var key in this.location.orgs) {
        var uid = this.location.orgs[key].uid;
        if (uid !== null && uid !== undefined && 
            this.C_orgMetaData !== null && this.C_orgMetaData !== undefined &&
            uid in this.C_orgMetaData && 
            this.C_orgMetaData[uid] !== null && this.C_orgMetaData[uid] !== undefined &&
            'name' in this.C_orgMetaData[uid] &&
            typeof(this.C_orgMetaData[uid]['name']) === 'string') {
          var tempName = this.C_orgMetaData[uid].name;
          this.location.orgs[key]['name'] = tempName;
        } else {
          this.location.orgs[key]['name'] = "";
        }
      }

      return _.orderBy(
        this.location.orgs,
        function(org) {
          return org.name.toLowerCase(); 
        }
      );
    },
    C_organizationName() {
      if(this.location.uid === null || this.location.uid === undefined || this.location.isOrg !== true) {
        return "";
      }
      //if data isn't loaded yet show the database UID
      if(this.location.uid in this.C_orgMetaData === false) {
        return this.location.uid;
      }

      if(this.C_orgMetaData[this.location.uid] !== null && 
        this.C_orgMetaData[this.location.uid] !== undefined &&
        'name' in this.C_orgMetaData[this.location.uid] &&
        typeof(this.C_orgMetaData[this.location.uid]['name']) === 'string'
        ) {
          return this.C_orgMetaData[this.location.uid]['name'];
        } else {
          return this.location.uid;
        }
    },
    C_systemName() {
      if(this.location.uid === null || this.location.uid === undefined || this.location.isSys !== true) {
        return "";
      }
      var obj_sys_uid = this.location.uid.replace('sys_', 'obj_');
      
      //if data isn't loaded yet show the database UID
      if(obj_sys_uid in this.C_objectsMetaData === false) {
        return this.location.uid;
      }

      if(this.C_objectsMetaData[obj_sys_uid] !== null && 
        this.C_objectsMetaData[obj_sys_uid] !== undefined &&
        'name' in this.C_objectsMetaData[obj_sys_uid] &&
        typeof(this.C_objectsMetaData[obj_sys_uid]['name']) === 'string'
        ) {
          return this.C_objectsMetaData[obj_sys_uid]['name'];
        } else {
          return this.location.uid;
        }
    },
    C_orgMetaData() {
      return window.vue_instance.$data.watchdog.orgMetaData;
    },
    C_objectsMetaData() {
      return window.vue_instance.$data.watchdog.objectsMetaData;
    },
    C_tooltipText() {
      var sys_count = 0;
      var sub_org_count = 0;
      var tooltip_text = "";

      //// counting sub orgs here
      var org_uid = this.location.uid;
      if (org_uid === null || org_uid === undefined) {
        return "Sub-orgs: UnKnown, Systems: UnKnown";
      }

      var sub_orgs_ids_list = [];
      var search_string = org_uid + "org_";
      
      for (var key in window.G_watchdog_data.IV_org_location_strings) {
        if (window.G_watchdog_data.IV_org_location_strings[key].indexOf(search_string) >= 0) {
          sub_orgs_ids_list.push(key);
        }
      }

      sub_org_count = sub_orgs_ids_list.length;
      ////</end> counting sub orgs here

      //// counting number of systems under syb-orgs
      
      // Counting systems of this org as well
      sub_orgs_ids_list.push(org_uid)

      for (let index in sub_orgs_ids_list) {
        let sub_org_uid = sub_orgs_ids_list[index];

        if (sub_org_uid in window.G_watchdog_data.IV_org_system_joins == true) {
          let systems = window.G_watchdog_data.IV_org_system_joins[sub_org_uid];

          for (let key in systems) {
            if (key !== "last_updated")
              sys_count++
          }
        }
      }
      ////</end> counting number of systems under syb-orgs

      tooltip_text = `Sub-orgs: ${sub_org_count}, Systems: ${sys_count}`;
      return tooltip_text;

    }
  },
  methods: {
  	passEventSetChildrenVisible() {
      this.$eemit("event-set-children-visible")
    },
    startMetaDataListener() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (this.location.uid !== null && this.location.uid !== undefined &&
        window.vue_instance.$data.watchdog.watchdogDbConnected === true &&
         typeof this.location.uid === 'string') {
        if(this.location.isOrg === true) {

          // params for listener(org_uid, instant_remove_listener, component_id)
          window.G_watchdog_data.initOrgMetaDataListener(this.location.uid, false, "c2");
        } else if(this.location.isSys === true) {

          // params for listener(org_uid, instant_remove_listener, component_id)
          window.G_watchdog_data.initSysMetaDataListener(this.location.uid, false, "c2");
          }
      } else if(this.location.isSys === true || this.location.isOrg === true) {
        setTimeout(this.startMetaDataListener(), 200);
      }
    },
    stopMetaDataListener() {

      // We'll keep listeners ON for first level orgs.
      if (this.depth < 1) {
        return;
      }
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (this.location.uid !== null && this.location.uid !== undefined &&
        window.vue_instance.$data.watchdog.watchdogDbConnected === true &&
         typeof this.location.uid === 'string') {
        if(this.location.isOrg === true) {

          // params for unSubListener(listener_type, uid, component_id)
          window.G_watchdog_data.bi7UnsubscribeSpecificListener('org_meta_data', this.location.uid, "c2");
        } else if(this.location.isSys === true) {

          // params for unSubListener(listener_type, uid, component_id)
          window.G_watchdog_data.bi7UnsubscribeSpecificListener('object_meta_data', this.location.uid.replace("sys_", "obj_"), "c2");
          }
      } else if(this.location.isSys === true || this.location.isOrg === true) {
        setTimeout(this.stopMetaDataListener(), 200);
      }
    },
    // startOrgSystemJoinsListener() {
    //   //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
    //   if (this.location.uid !== null && this.location.uid !== undefined &&
    //     window.vue_instance.$data.watchdog.watchdogDbConnected === true &&
    //      typeof this.location.uid === 'string') {
    //     if(this.location.isOrg === true) {
    //       window.G_watchdog_data.InitOrgSystemJoinsListener(this.location.uid, false, "c2");
    //     }
    //   } else if(this.location.isSys === true || this.location.isOrg === true) {
    //     setTimeout(this.startOrgSystemJoinsListener(), 200);
    //   }
    // },
    // stopOrgSystemJoinsListener() {

    //   // We'll keep listeners ON for first level orgs.
    //   if (this.depth < 1 && this.location.nodes === undefined) {
    //     return;
    //   }
    //   //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
    //   if (this.location.uid !== null && this.location.uid !== undefined &&
    //     window.vue_instance.$data.watchdog.watchdogDbConnected === true &&
    //      typeof this.location.uid === 'string') {
    //     if(this.location.isOrg === true) {
    //       window.G_watchdog_data.bi7UnsubscribeSpecificListener('org_system_joins', this.location.uid, "c2");
    //     }
    //   } else if(this.location.isSys === true || this.location.isOrg === true) {
    //     setTimeout(this.stopOrgSystemJoinsListener(), 200);
    //   }
    // },

    // stop the firebase listeners for current location based on is this system or organisation.
    stopLocationListeners() {
      this.stopMetaDataListener()
      // if (this.location.isOrg === true) {
      //   this.stopOrgSystemJoinsListener();
      // }
    },

    // start the firebase listeners for current location based on is this system or organisation.
    startLocationListeners() {
      this.startMetaDataListener()
      // if (this.location.isOrg === true) {
      //   this.startOrgSystemJoinsListener();
      // }
    },
    hideChildren() {
      
      // // will send this org_uid and FALSE command to stop listeners for child nodes.
      this.DV_listenersCommandToChild = {'orgUid': this.location.uid, 'command': false};
      this.DV_showSystemStatusIndicator = false;

      //while the user is searching don't overwrite their non-searching tree state
      if (this.searchQuery !== false) { 
        this.DV_SearchModeShowChildrenFlag = false;  
        return; 
      }
      this.DV_showChildrenFlag = false;      

      this.$store.commit("c2setPresetOrgExpanded", [this.presetName, this.location.key, this.DV_showChildrenFlag]);
    },
    showChildren() {
      this.startLocationListeners();

      // will send this org_uid and TRUE command to start listeners for child nodes.
      this.DV_listenersCommandToChild = {'orgUid': this.location.uid, 'command': true};
      this.DV_showSystemStatusIndicator = true;
      //while the user is searching don't overwrite their non-searching tree state
      if (this.searchQuery !== false) { 
        this.DV_SearchModeShowChildrenFlag = true;  
        return; 
      }
      this.DV_showChildrenFlag = true;

      this.$store.commit("c2setPresetOrgExpanded", [this.presetName, this.location.key, this.DV_showChildrenFlag]);
    },
    selectOrg() {
      this.$emit("pass-select-org", [this.location.key, this.location.uid]);
    },
    selectSys() {
      this.$emit("pass-select-system", [this.location.key, this.location.uid]);
    },
    eventEditOrg() {
      this.$emit("pass-event-edit-org", this.location.uid);
    },
    eventEditSys() {
      this.$emit("pass-event-edit-sys", this.location.uid);
    },
    eventShowReporting() {
      this.$emit("pass-event-show-reporting", this.location.uid);
    },
    eventShowDetails() {
      this.$emit("pass-event-show-details", this.location.uid);
    },
    eventShowDoghouse() {
      this.$emit("pass-event-show-doghouse", this.location.uid);
    },
    passEventUnSelectItem() {
      this.$emit("pass-event-unselect-selected-item")
    },
    passSelectOrg(msg) {
      this.$emit("pass-select-org", msg);
    },
    passSelectSystem(msg) {
      this.$emit("pass-select-system", msg);
    },
    passEventEditOrg(msg) {
      this.$emit("pass-event-edit-org", msg);
    },
    passEeventEditSys(msg) {
      this.$emit("pass-event-edit-sys", msg);
    },
    passEventShowDoghouse(msg) {
      this.$emit("pass-event-show-doghouse", msg);
    },
    passEventShowDetails(msg) {
      this.$emit("pass-event-show-details", msg);
    },
    passEventShowReporting(msg) {
      this.$emit("pass-event-show-reporting", msg);
    },
    eventSearchQueryOrgMatch(msg) {
      if (msg !== this.searchQueryRequestTimestamp) { return;}      
      this.$emit("event-search-query-deep-match", msg);
      this.DV_searchQuerySubOrgMatchFlag = true;
    },
    eventSearchQuerySystemMatch(msg) {
      if (msg !== this.searchQueryRequestTimestamp) { return;}
      this.$emit("pass-event-search-query-system-match", msg);
      this.DV_searchQuerySubSystemMatchFlag = true;
    },
    passEventSearchQuerySystemMatch(msg) {
      if (msg !== this.searchQueryRequestTimestamp) { return;}      
      this.DV_searchQuerySubSystemMatchFlag = true;
      this.$emit("event-search-query-deep-match", msg);
    },
    passEventSearchQueryDeepMatch(msg) {
      if (msg !== this.searchQueryRequestTimestamp) { return;}      
      this.$emit("event-search-query-deep-match", msg);      
      this.DV_searchQueryDeepMatchFlag = true;
    },
    expandAllChildren() {
      this.showChildren();
      this.DV_expandCollapseCommandToChild = "E" + new Date().getTime().toString();
    },
    collapseAllChildren() {
      this.hideChildren(); 
      this.DV_expandCollapseCommandToChild = "C" + new Date().getTime().toString();
    },
    isSearchQueryMatched(name, query) {      
      var ret = true;
      query = query.toLowerCase();
      name = name.toLowerCase();
      var query_parts = query.split(" ");

      for(var index in query_parts) {
        var word = query_parts[index];
        var matchedIndex = name.indexOf(word);
        if (matchedIndex === -1) {
          ret = false;
          break;
        }
      }
      return ret;
    },
    setSelectedItemKey(msg) {
      this.$emit('set-selected-item-key', msg);
    },
    setActiveOrg() {
      if (this.location.uid !== null && this.location.uid !== undefined && 
          this.activeOrgUid !== null && this.activeOrgUid !== undefined &&  
          this.location.uid === this.activeOrgUid) {
        if (this.selectedItemKey !== this.location.key) {
          this.$emit('set-selected-item-key', this.location.key);
        }
      }
    },
    setActiveSys() {
      if (this.location.uid !== null && this.location.uid !== undefined && 
          this.activeSysUid !== null && this.activeSysUid !== undefined && 
          this.location.uid === this.activeSysUid) {
        if (this.selectedItemKey !== this.location.key) {
          this.$emit('set-selected-item-key', this.location.key);
        }
      }
    }
  },
  watch: {
    userHasPermissionsFlag: function(val) {      
      //user can always see orgs they have access too and systems under them
      if(this.userHasPermissionsFlag === true) {
        this.DV_hidePartnerOrg = false;
        this.DV_childDepth = this.depth + 1;
        return;
      }
      //don't show partner orgs and partner sub-orgs to those who don't have access to them, they are subscribers and want to their org as the top level one
      if(this.isOrg === true &&
        this.location.uid in this.C_orgMetaData &&
        'type' in this.C_orgMetaData[this.location.uid] &&
              ( this.C_orgMetaData[this.location.uid]['type'] === "1" ||  
              this.C_orgMetaData[this.location.uid]['type'] === "8")
      ) { 
        this.DV_childDepth = this.depth;
        this.DV_hidePartnerOrg = true;
        return;
        }

      //even if the user doesn't have access to the org they should see non-partner parent orgs
      //this.DV_hidePartnerOrg = false;
      //this.DV_childDepth = this.depth + 1;
        
    },

    expandCollapseCommand: function(val) {
      if (val === null || val.length < 1) {
        return;
      }

      if (val[0] === "E") {
        this.showChildren();
      } 
      if (val[0] === "C") {
        this.stopLocationListeners();
        this.hideChildren();
      }
      
      this.DV_expandCollapseCommandToChild = this.expandCollapseCommand;
    },
    searchQuery: {
      handler() {
        if (this.searchQuery === false) {
          this.DV_searchQueryMatchFlag = false;
          this.DV_searchQuerySubOrgMatchFlag = false;
          this.DV_searchQuerySubSystemMatchFlag = false;
          this.DV_searchQueryDeepMatchFlag = false;
          this.DV_searchQueryToChidlren = this.searchQuery;
          this.DV_SearchModeShowChildrenFlag = false;
          return
        }
        //clearing the flags prevents previous results from still showing up so when a user goes from "de" to "demo" it clears results for "de"
        this.DV_SearchModeShowChildrenFlag = false;
        this.DV_searchQuerySubOrgMatchFlag = false;
        this.DV_searchQuerySubSystemMatchFlag = false;
        this.DV_searchQueryDeepMatchFlag = false;

        if (this.location.uid && this.location.isSys && this.location.uid.replace('sys_','obj_') in this.C_objectsMetaData && this.C_objectsMetaData[this.location.uid.replace('sys_','obj_')] !== null && this.C_objectsMetaData[this.location.uid.replace('sys_','obj_')] !== undefined) {
          var tempName = this.C_objectsMetaData[this.location.uid.replace('sys_','obj_')].name;
          if (tempName === undefined || tempName === null) { 
            this.DV_searchQueryMatchFlag = false;
          } else if (this.isSearchQueryMatched(tempName, this.searchQuery) === true) {
            this.$emit('event-search-query-system-match', this.searchQueryRequestTimestamp);
            this.DV_searchQueryMatchFlag = true;
          } else {
            this.DV_searchQueryMatchFlag = false;
          }
        } else if (this.location.uid && this.location.isOrg && this.location.uid in this.C_orgMetaData) {
          var tempName = this.C_orgMetaData[this.location.uid].name;        
          if (tempName === undefined || tempName === null) {
            this.DV_searchQueryMatchFlag = false;
          } else if (this.isSearchQueryMatched(tempName, this.searchQuery) === true) {
            this.$emit('event-search-query-org-match', this.searchQueryRequestTimestamp);
            this.DV_searchQueryMatchFlag = true;
          } else {
            this.DV_searchQueryMatchFlag = false;
          }
        }
        this.DV_searchQueryToChidlren = this.searchQuery;
        this.DV_searchQueryRequestTimestampToChildren = this.searchQueryRequestTimestamp;
      },
      immediate: true
    },
    // this watch is used to start or stop the listener for the current location org/system based on the command from parent and pass the command to child nodes by updating orgUid key of DV_listenersCommandToChild
    listenersCommandToChild: {
      handler: function(val) {
        if (this.lastOrgUid === val.orgUid) {
          if (val.command === true) {
            this.startLocationListeners();
            this.DV_showSystemStatusIndicator = true;
            // Here we'll forward the True command to child if current location is already expanded.
            if (this.$store.state.presetStates[this.presetName][this.location.key] === true) {
              this.DV_listenersCommandToChild = {'orgUid': this.DV_actualLastOrgUid, 'command': true}
            } else {

              // If the location key is not in preset data but locatios's parent is expanded we need to start listeners for it's childs as well.
              if (this.location.isOrg === true || this.location.isSys === true) {
                if (this.$store.state.presetStates[this.presetName][this.parentKey] === true){
                  this.DV_listenersCommandToChild = {'orgUid': this.DV_actualLastOrgUid, 'command': true}
                }
              } else if (this.$store.state.presetStates[this.presetName][this.parentKey] === true) {
                this.DV_listenersCommandToChild = {'orgUid': this.DV_actualLastOrgUid, 'command': true}
              }

              // </end> If the location key is not in preset data but locatios's parent is expanded we need to start listeners for it's childs as well.
            }

            // if the command is false simply stop listeners for this location and all its child locations.
          } else {
            this.stopLocationListeners();
            this.DV_showSystemStatusIndicator = false;
            this.DV_listenersCommandToChild = {'orgUid': this.DV_actualLastOrgUid, 'command': false}
          }
        }
      },
      deep: true
    }
  },
  mounted: function() {

    // We'll keep listeners ON for first level orgs.
    if (this.depth < 2) {
      this.startLocationListeners();
      this.DV_showSystemStatusIndicator = true;
    }
    this.$nextTick(function() {
      this.DV_expandCollapseCommandToChild = this.expandCollapseCommand;
      
      /// if location.key is present in preset settings start data listeners for this location
      if (
        this.location.key !== null && this.location.key !== undefined &&
        this.presetName in this.$store.state.presetStates &&
        this.location.key in this.$store.state.presetStates[this.presetName]
      ) {
        let flag = this.$store.state.presetStates[this.presetName][this.location.key];
        this.DV_showChildrenFlag = flag;

        if (flag === true) {
          this.startLocationListeners();
        } else {
          if ((this.location.isOrg === true) || this.location.isSys === true) {
            if (this.$store.state.presetStates[this.presetName][this.parentKey] === true){
              this.startLocationListeners();
            }
          }
        }
        //// If the location key is not in preset data but locatios's parent is expanded we need to start listeners for it's childs as well.
      } else if (
        this.parentKey in this.$store.state.presetStates[this.presetName] &&
        this.$store.state.presetStates[this.presetName][this.parentKey] === true
      ) {
        this.startLocationListeners();
      }
        //// </end> If the location key is not in preset data but locatios's parent is expanded we need to start listeners for it's childs as well.
      ///</end> if location.key is present in preset settings start data listeners for this location

      /// Enable the systems status indicator only if system's parent is in visible state
      if (this.location.isSys === true &&
          this.parentKey in this.$store.state.presetStates[this.presetName] &&
          this.$store.state.presetStates[this.presetName][this.parentKey] === true
      ) {
        this.DV_showSystemStatusIndicator = true;
      }
      ///</end> Enable the systems status indicator only if system's parent is in visible state

      if (this.location.key === undefined || this.location.key === null) {
        this.DV_actualParentKey = this.parentKey;
      } else {
        this.DV_actualParentKey = this.location.key;
      }

      if (this.location.uid && this.location.isSys) {
        this.DV_actualLastOrgUid = this.lastOrgUid;
      } else if (this.location.uid && this.location.isOrg) {
        this.DV_actualLastOrgUid = this.location.uid;
      } else if (this.lastOrgUid === null) {
        this.DV_actualLastOrgUid = "0";
      } else {
        this.DV_actualLastOrgUid = this.lastOrgUid;
      }

      if(this.location.isSys === true || this.location.isOrg === true) {
        this.bi10GetOrgPermissions(this.DV_actualLastOrgUid);
      }
      this.setActiveOrg();
      this.setActiveSys();
    });
  },
};
</script>





// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s1MyOrganizations/c2SystemOrgTreeMenu.vue